type StylesheetsProps = {
  css: string
}

export function Stylesheets({ css }: StylesheetsProps) {
  return <style>{css}</style>
}
